import { render, staticRenderFns } from "./SignIn1.vue?vue&type=template&id=0ec2b488"
import script from "./SignIn1.vue?vue&type=script&lang=js"
export * from "./SignIn1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports